const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        linesContainer: cc.Node,
        idLabel: cc.Label,
        dateLabel: cc.Label,
        betAmountLabel: cc.Label,
        winLabel: cc.Label,
        balanceLabel: cc.Label
    },

    setEmptyData () {
        this.idLabel.string = '';
        this.dateLabel.string = '';
        this.betAmountLabel.string = '';
        this.winLabel.string = '';
        this.balanceLabel.string = '';
    },

    setData ({ roundId, endDate, bet, win, balanceAfter }) {
        const time = new Date(endDate);
        this.idLabel.string = roundId;
        this.dateLabel.string = time.toLocaleString('en-GB');
        this.betAmountLabel.string = i18n.formatCurrency(bet);
        this.winLabel.string = i18n.formatCurrency(win);
        this.balanceLabel.string = i18n.formatCurrency(balanceAfter);
    }
});
